export default "__VITE_ASSET__Debw44vP__"